import Glide, { Breakpoints, Controls, Swipe, Images } from '@glidejs/glide/dist/glide.modular.esm';
import { getDir } from '../../common/components/utils/utils';

const SELECTORS = {
	root: '[data-slider-testimonials]',
};

export class TestimonialsSlider {
	constructor() {
		this.rootEl = document.querySelector(SELECTORS.root);

		const requiredElements = [this.rootEl];

		if (requiredElements.some((el) => !el)) {
			return;
		}

		this.setup();
	}

	static init() {
		// eslint-disable-next-line
		new TestimonialsSlider();
	}

	setupSlider() {
		this.slider = new Glide(this.rootEl, {
			type: 'carousel',
			perView: 1,
			gap: 32,
			rewind: false,
			direction: getDir(),
			animationTimingFunc: 'linear',
			swipeThreshold: 40,
		}).mount({ Controls, Breakpoints, Swipe, Images });
	}

	setup() {
		this.setupSlider();
	}
}
